import { ui } from "@patient-watch/ui";
import { LOCALE_LABELS, SUPPORTED_LOCALES, type SupportedLocale } from "@patient-watch/i18n";
import { Languages } from "lucide-react";
import { useAuthCopy } from "./authCopy";
import { useAppLocale } from "./LocaleProvider";
import { useSetAppLocale } from "./useSetAppLocale";

/** Compact language picker for unauthenticated auth pages. */
export function AuthLanguageSwitcher() {
    const copy = useAuthCopy();
    const { locale } = useAppLocale();
    const setLocale = useSetAppLocale();

    return (
        <div className="flex items-center gap-2">
            <Languages aria-hidden className="size-4 text-muted-foreground shrink-0" />
            <ui.Select value={locale} onValueChange={(value) => setLocale(value as SupportedLocale)}>
                <ui.SelectTrigger
                    className="bg-transparent shadow-none px-2 border-0 w-auto min-w-[9rem] h-8 text-muted-foreground hover:text-foreground"
                    data-testid="auth-language-select-trigger"
                    aria-label={copy.languageLabel}
                >
                    <ui.SelectValue />
                </ui.SelectTrigger>
                <ui.SelectContent align="end">
                    {SUPPORTED_LOCALES.map((supportedLocale) => (
                        <ui.SelectItem
                            key={supportedLocale}
                            value={supportedLocale}
                            data-testid={`auth-language-option-${supportedLocale}`}
                        >
                            {LOCALE_LABELS[supportedLocale]}
                        </ui.SelectItem>
                    ))}
                </ui.SelectContent>
            </ui.Select>
        </div>
    );
}
